import { createTheme } from '@mui/material/styles'
import { extend } from 'lodash'

import breakpoints from './breakpoints'

const theme = createTheme({
  breakpoints: {
    ...breakpoints,
  },
})

export default {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: ({ ownerState }) =>
        extend(
          {
            [theme.breakpoints.up('xs')]: {
              minWidth: 'unset',
              padding: '4px 6px',
            },
            [theme.breakpoints.up('md')]: {
              padding: '6px 20px',
            },
            [theme.breakpoints.up('lg')]: {
              padding: '8px 32px',
            },
            '&:hover': extend(
              ownerState.variant === 'outlined' && {
                borderWidth: `2px`,
              },
            ),
          },
          ownerState.variant === 'outlined' && {
            [theme.breakpoints.up('xs')]: {
              minWidth: 'unset',
              padding: '2px 4px',
            },
            [theme.breakpoints.up('md')]: {
              padding: '4px 18px',
            },
            [theme.breakpoints.up('lg')]: {
              padding: '6px 30px',
            },
            border: `2px solid currentColor`,
          },
          ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              '&:hover': {
                color: '#fff',
              },
            },
        ),
    },
  },
  // MuiSelect: {
  //   defaultProps: {
  //     MenuProps: {
  //       PaperProps: {
  //         style: {

  //         },
  //       },
  //     },
  //   },
  //   styleOverrides: {
  //   },
  // },
}
